var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ mounted: _vm.mounted },attrs:{"id":"app","data-hydration-completed":_vm.isHydrationCompleted}},[_c(_vm.resolvedTemplate,{tag:"component",attrs:{"modifier":_vm.layoutModifier}}),_vm._v(" "),_c('div',{attrs:{"id":"appLoader","data-urls":_vm.printDataUrls()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }